module.exports = __webpack_public_path__ + "static/img/2902_phase_function_Paper_Points.9381806.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2902_phase_function_Paper_Points.png
// module id = QScG
// module chunks = 0